"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Card = require("./Card.styles");

var _elements = require("../../styles/elements");

var Card = function Card(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      className = _ref.className,
      footer = _ref.footer;
  var onlyHasBody = !title && !description;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Card.styles.base,
    className: (0, _clsx["default"])('grui box-shadow-sm', className),
    children: [!onlyHasBody && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsxs)("div", {
        css: [_elements.text.styles.textSm, _elements.text.styles.fontMedium, process.env.NODE_ENV === "production" ? "" : ";label:Card;"],
        className: "grui p-8 pl-12",
        children: [title, description && (0, _jsxRuntime.jsx)("p", {
          css: [_elements.paragraph.styles.preflight, _elements.text.styles.text2Xs, _elements.text.styles.textDark, _elements.text.styles.fontNormal, process.env.NODE_ENV === "production" ? "" : ";label:Card;"],
          children: description
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        css: _elements.divider.styles.base,
        role: "separator"
      })]
    }), (0, _jsxRuntime.jsx)("div", {
      className: "grui p-12",
      children: children
    }), footer && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)("div", {
        css: _elements.divider.styles.base,
        role: "separator"
      }), (0, _jsxRuntime.jsx)("div", {
        className: "grui px-12 py-5",
        css: _Card.styles.footer,
        children: footer
      })]
    })]
  });
};

Card.propTypes = {
  className: _propTypes.string,
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  description: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  footer: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
Card.defaultProps = {
  className: undefined,
  title: undefined,
  description: undefined,
  children: undefined,
  footer: undefined
};
var _default = Card;
exports["default"] = _default;
//# sourceMappingURL=Card.js.map